import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Companies from "@/pages/Companies";
import Solutions from "@/pages/Solutions";
import InsightArticle from "@/pages/InsightArticle";
import InsightsArchive from "@/pages/InsightsArchive";
import CompanyPage from "@/pages/CompanyPage";
import Partnerships from "@/pages/Partnerships";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import HapoIntel from "@/pages/HapoIntel";
import { Toaster } from "@/components/ui/sonner";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <div className="bg-ink font-sora text-white">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/companies/hapo-intel" element={<Navigate to="/companies/hapo-intelligence" replace />} />
            <Route path="/companies/hapo-intelligence" element={<HapoIntel />} />
            <Route path="/companies/:slug" element={<CompanyPage />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/insights" element={<InsightsArchive />} />
            <Route path="/insights/:id" element={<InsightArticle />} />
            <Route path="/partnerships" element={<Partnerships />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </BrowserRouter>
  );
}
